import React, { useState, useRef, useEffect } from "react";
import "../styles/TooltipStyle.css"; // Import the CSS file
import "../styles/table_styles/Table_Styles.css";
import Tooltip from "@mui/material/Tooltip";
import { createTheme, ThemeProvider } from "@mui/material/styles";
interface TooltipProps {
  text: string;
  color?: string;
}

const QuestionTooltip: React.FC<TooltipProps> = ({ text, color }) => {
  const [isTextOverflow, setIsTextOverflow] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const theme = createTheme({
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: "#281A10", // Custom background color
            color: "#fff", // Text color
            borderRadius: "8px", // Border radius
            maxWidth: "500px",
            fontWeight: 400,
            fontSize: "14px",
            padding: "12px",
            opacity: "0.9 !important",
          },
          arrow: {
            color: "#281A10", // Arrow color to match tooltip background
          },
        },
      },
    },
  });
  useEffect(() => {
    const checkOverflow = () => {
      if (containerRef.current) {
        const container = containerRef.current;
        setIsTextOverflow(container.scrollHeight > container.clientHeight);
      }
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);

    return () => {
      window.removeEventListener("resize", checkOverflow);
    };
  }, [text]);

  return (
    <div
      ref={containerRef}
      className="truncated-text"
      style={{
        maxHeight: "calc(2 * 2.0em)",
      }}
    >
      <div className="tablebodyCell1">{text}</div>
      {isTextOverflow && (
        <ThemeProvider theme={theme}>
          <Tooltip title={text} arrow placement="top">
            <span
              className="read-more"
              style={{ backgroundColor: color ? color : "white" }}
              data-tooltip-id="my-tooltip-1"
            >
              {" "}
              Read more..
            </span>
          </Tooltip>
        </ThemeProvider>
      )}
    </div>
  );
};

export default QuestionTooltip;
